// @flow
import styled, { css } from 'styled-components';
import GtArrowIcon from '../icons/gt-arrow';
import { cleanWhite, jetBlack } from '../colors';
import AccordionTheme from '../accordion/theme';
import AccordionPanelTheme from '../accordion/panel/theme';
import PrimaryButtonTheme from '../buttons/primary/theme';
import { media } from '..';
export var HeadImageCss = css(["display:block;width:100%;height:8.06rem;border-radius:2rem;transition-delay:0.5s;transition:border-radius 0.4s cubic-bezier(.65,.05,.36,1);[aria-expanded=true] &{border-radius:2rem 2rem 0 0;transition:border-radius 0.4s cubic-bezier(.65,.05,.36,1);}"]);
var theme = {
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "mss3y9-0"
  })(["width:100%;"]),
  Head: styled.div.withConfig({
    displayName: "theme__Head",
    componentId: "mss3y9-1"
  })(["position:relative;width:100%;border-radius:2rem;transition-delay:0.5s;transition:border-radius 0.4s cubic-bezier(.65,.05,.36,1);[aria-expanded=true] &{border-radius:2rem 2rem 0 0;transition:border-radius 0.4s cubic-bezier(.65,.05,.36,1);}"]),
  HeadImage: styled.img.withConfig({
    displayName: "theme__HeadImage",
    componentId: "mss3y9-2"
  })(["", ""], HeadImageCss),
  HeadDarker: styled.div.withConfig({
    displayName: "theme__HeadDarker",
    componentId: "mss3y9-3"
  })(["position:absolute;left:0;top:0;width:100%;height:100%;background:", ";opacity:.5;border-radius:2rem;transition-delay:0.5s;transition:border-radius 0.4s cubic-bezier(.65,.05,.36,1);[aria-expanded=true] &{border-radius:2rem 2rem 0 0;transition:border-radius 0.4s cubic-bezier(.65,.05,.36,1);}"], jetBlack()),
  HeadIcon: styled(GtArrowIcon).attrs({
    direction: 'top',
    color: cleanWhite()
  }).withConfig({
    displayName: "theme__HeadIcon",
    componentId: "mss3y9-4"
  })(["position:absolute;right:1.6rem;top:2.84rem;transition:transform 0.3s;transform:rotate(-180deg) !important;[aria-expanded=true] &{transform:rotate(0deg) !important;}"]),
  Title: styled.div.withConfig({
    displayName: "theme__Title",
    componentId: "mss3y9-5"
  })(["position:absolute;left:0;top:0;width:17rem;padding:.8rem 0 0 1.6rem;font-size:2.4rem;color:", ";text-transform:uppercase;"], cleanWhite()),
  Body: styled.div.withConfig({
    displayName: "theme__Body",
    componentId: "mss3y9-6"
  })(["display:flex;flex-direction:column;padding:2.4rem 1.6rem 0 1.6rem;background-color:", ";border-radius:0 0 2rem 2rem;"], function (pr) {
    return pr.color;
  }),
  Logo: styled.img.withConfig({
    displayName: "theme__Logo",
    componentId: "mss3y9-7"
  })(["align-self:flex-start;height:3.2rem;width:15rem;object-fit:contain;"]),
  Text: styled.div.withConfig({
    displayName: "theme__Text",
    componentId: "mss3y9-8"
  })(["padding:1.6rem 0 0 0;font-size:1.6rem;color:", ";", "{font-size:2.4rem;font-weight:200;line-height:150%;}"], cleanWhite(), media.sm),
  Button: Object.assign({}, PrimaryButtonTheme, {
    Button: styled(PrimaryButtonTheme.Button).withConfig({
      displayName: "theme__Button",
      componentId: "mss3y9-9"
    })(["align-self:center;margin:2.4rem 0;font-size:1.4rem;", "{font-size:2rem;}"], media.sm),
    Hover: styled(PrimaryButtonTheme.Hover).withConfig({
      displayName: "theme__Hover",
      componentId: "mss3y9-10"
    })(["padding:0 5rem;"])
  }),
  AccordionTheme: Object.assign({}, AccordionTheme, {
    Panel: Object.assign({}, AccordionPanelTheme, {
      Body: styled.div.withConfig({
        displayName: "theme__Body",
        componentId: "mss3y9-11"
      })(["overflow:hidden;will-change:height;transition-delay:0.5s;transition:height 0.4s cubic-bezier(.65,.05,.36,1);height:", ";margin-bottom:3.2rem;"], function (pr) {
        return pr.heightProp;
      }),
      Content: styled.div.withConfig({
        displayName: "theme__Content",
        componentId: "mss3y9-12"
      })(["opacity:", ";transition-delay:0.5s;transition:opacity 0.3s linear 0.18s;"], function (pr) {
        return pr.visible ? 1 : 0;
      })
    })
  })
};
export default theme;